<template>
  <div id="sequence-converter">
    <h1>{{ title }}</h1>
    <div>
      <p>
        Sequence Converter supports the conversion of jubeat's sequence files between arcade (e.g.,
        <code>adv.eve</code>) and jubeat plus (e.g.,
        <code>adv_seq</code>) formats that are in plaintext.
      </p>
      <form method="post" enctype="multipart/form-data" @submit="validateForm">
        <table>
          <tr>
            <th colspan="2">
              Files
              <code>[20MB maximum]</code>
            </th>
          </tr>
          <tr>
            <td colspan="2">
              <input
                type="file"
                name="file"
                id="file-chooser"
                @change="handleFile"
                multiple
                required
              />
            </td>
          </tr>
          <tr>
            <th colspan="2">Conversion Type</th>
          </tr>
          <tr>
            <td>
              <input
                type="radio"
                name="conversion-type"
                id="PLUS_TO_AC"
                value="PLUS_TO_AC"
                required
                checked
              />
              <label for="PLUS_TO_AC">plus to arcade</label>
            </td>
            <td>
              <label for="PLUS_TO_AC">
                Convert jubeat plus
                <code>seq</code> files to jubeat arcade
                <code>eve</code> files.
                <br />For each filename, the
                <code>"seq_"</code> at the start (if exists) will be removed, and
                <code>".eve"</code> will be appended to it.
              </label>
            </td>
          </tr>
          <tr>
            <td>
              <input
                type="radio"
                name="conversion-type"
                id="AC_TO_PLUS"
                value="AC_TO_PLUS"
                required
              />
              <label for="AC_TO_PLUS">arcade to plus</label>
            </td>
            <td>
              <label for="AC_TO_PLUS">
                Convert jubeat arcade
                <code>eve</code> files to jubeat plus
                <code>seq</code> files.
                <br />For each filename, the
                <code>".eve"</code> at the end (if exists) will be removed, and
                <code>"seq_"</code> will be prepended to it.
              </label>
            </td>
          </tr>
          <tr v-if="errors.length">
            <th colspan="2" class="error">Error(s)</th>
          </tr>
          <tr v-if="errors.length">
            <td colspan="2" class="error">
              <ul>
                <li v-for="error in errors" v-bind:key="`error-${error.code}`">{{ error.msg }}</li>
              </ul>
            </td>
          </tr>
        </table>
        <input type="submit" value="Submit" v-show="files.length > 0" />
      </form>
    </div>
    <footer>
      <pre>SEQUENCE CONVERTER COMES WITH ABSOLUTELY NO WARRANTY, USE AT YOUR OWN RISK.</pre>
    </footer>
  </div>
</template>

<script>
export default {
  name: "SequenceConverter",
  data: () => ({
    files: [],
    errors: [],
  }),
  computed: {},
  watch: {},
  methods: {
    clickId(labelId) {
      document.getElementById(labelId).click();
    },
    chooseFile() {
      document.getElementById("file-chooser").click();
    },
    handleFile(event) {
      this.files = event.target.files;
    },
    validateForm(event) {
      this.errors = [];
      let size = 0;

      for (let file of this.files) {
        size += file.size;
        console.log(file.size);
      }
      if (size > 2097152)
        // file exceeds 2MB
        this.errors.push({
          code: 3,
          msg: "Total file size exceeds 2MB!",
        });

      if (!this.errors.length) return true;
      event.preventDefault();
    },
  },
  props: {
    title: String,
  },
};
</script>

<style scoped>
.content {
  margin: 0 auto;
}

p,
ul,
li {
  margin: 0;
}

td,
th {
  vertical-align: top;
  text-align: start;
}

tr:not(:first-of-type) th {
  padding-top: 10px;
}

input {
  font-family: monospace;
}

input + label,
input + input {
  padding-left: 3px;
  font-family: monospace;
}

td + td {
  padding-left: 10px;
  overflow-x: auto;
}

.error {
  color: crimson;
}

#custom-key {
  width: 350px;
}

footer,
pre {
  white-space: -moz-pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
}
</style>